export const MODAL_EXIT_ACTIVE = 'MODAL_EXIT_ACTIVE';
export const MODAL_EXIT_SHOW = 'MODAL_EXIT_SHOW';
